export const strings = {
  english: {
    question: 'Do you have a voucher? Redeem it ',
    here: 'here.',
  },

  japan: {
    question: 'メディアインテグレーションのバウチャーをお持ちの方は',
    question2: 'から認証してください',
    here: 'こちら',
  },
};
